import { Injectable } from "@angular/core";
import { PermissionEnum } from "src/app/models/auth0/permission.enum";
import { UserService } from "../user/user.service";

@Injectable({
    providedIn: "root",
})
export class PermissionsService {
    constructor(private _userService: UserService) {}

    /**
     * Check if the current web user has a specific list of permissions
     * @param permission The user required permissions
     * @returns Whether the user have all of the permissions or not
     */
    public hasPermissions(permission: PermissionEnum): boolean {
        return this._userService.userPermissions.includes(permission.toString());
    }
}
